import { AxiosInstance } from 'axios';

import { FormName } from '@topconagriculture/feed-types';

import { APIManagerConfig } from '../apiManager';
import { CreateRationPayload, PreviewRationCreation } from '../../../store/application/recipes/appRecipes.types';

const RecipeServiceFactory = ({ HTTPBase, config }: { HTTPBase: AxiosInstance; config: APIManagerConfig }) => {
  return {
    getRecipeList: (): Promise<any> =>
      HTTPBase.get(`farm/${config.farmId}/rations?filter=nopremix`).then((res) => res.data),
    getRecipe: (recipeId): Promise<any> =>
      HTTPBase.get(`farm/${config.farmId}/rations/${recipeId}`).then((res) => res.data),
    createRecipe: (payload, formName: FormName): Promise<any> =>
      HTTPBase.post(`farm/${config.farmId}/rations`, payload, { headers: { formName } }).then((res) => res.data),
    simulateCreateRecipe: (payload: CreateRationPayload): Promise<PreviewRationCreation> =>
      HTTPBase.post(`farm/${config.farmId}/rations?nosave=true`, payload).then((res) => res.data),
    editRecipe: (recipeId, payload, formName: FormName): Promise<any> =>
      HTTPBase.patch(`farm/${config.farmId}/rations/${recipeId}`, payload, { headers: { formName } }).then(
        (res) => res.data,
      ),
    simulateEditRecipe: (recipeId, payload): Promise<any> =>
      HTTPBase.patch(`farm/${config.farmId}/rations/${recipeId}?nosave=true`, payload).then((res) => res.data),
    deleteRecipe: (recipeId, formName: FormName): Promise<any> =>
      HTTPBase.delete(`farm/${config.farmId}/rations/${recipeId}`, { headers: { formName } }).then((res) => res.data),
  };
};

export default RecipeServiceFactory;
